var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-insights" },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 4, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Total Product Intraction Time:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [_vm._v(_vm._s(_vm.productTotalTimeMinutes / 60) + " Hr")]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Avg Product Intraction Time:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.productAvgEngagementMinutes) + " Minutes"
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Lowest Product Intraction:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.productFastestActivityMinutes) + " Minutes"
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Maximum Product Intraction:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.productSlowestActivityminutes) + " Minutes"
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }